/**
 * Русские названия кодов справочника (T11.5, вынесено в T11.8).
 *
 * Справочник отдаёт коды, а человеку нужны слова. Таблица жила в экране
 * фильтров, пока читатель был один; с появлением карточки объявления их
 * стало двое, а две копии такой таблицы расходятся непременно — и
 * разойдутся молча, потому что «suv» в одном месте и «внедорожник» в
 * другом выглядят одинаково правдоподобно.
 *
 * Перечень сверен с живым ответом `GET /v1/dictionaries/meta`, а не
 * выписан по памяти: там `cabriolet`, а не `cabrio`, и `front` / `rear`
 * / `all`, а не `fwd` / `rwd` / `awd`.
 */

const LABELS: Record<string, string> = {
  sedan: 'седан',
  hatchback: 'хэтчбек',
  wagon: 'универсал',
  suv: 'внедорожник',
  coupe: 'купе',
  minivan: 'минивэн',
  pickup: 'пикап',
  cabriolet: 'кабриолет',
  liftback: 'лифтбек',
  van: 'фургон',
  limousine: 'лимузин',
  manual: 'механика',
  automatic: 'автомат',
  robot: 'робот',
  variator: 'вариатор',
  front: 'передний',
  rear: 'задний',
  all: 'полный',
  petrol: 'бензин',
  diesel: 'дизель',
  hybrid: 'гибрид',
  electric: 'электро',
  gas: 'газ',
  other: 'прочее',
  private: 'частник',
  dealer: 'дилер',
  unknown: 'не указан',
  avito: 'Avito',
  autoru: 'Auto.ru',
  drom: 'Drom',
};

/**
 * Слово по коду.
 *
 * Незнакомый код показывается как есть: английское слово лучше пустой
 * подписи. Площадки заводят новые значения без предупреждения, и экран,
 * молча теряющий на них слово, выглядит сломанным.
 */
export function label(code: string): string {
  return LABELS[code] ?? code;
}
